import { CoreDataSecurityMonitorsName } from './name';
import { createRemoveSyncSlice } from '@sonar-software/xuder';
import { DeleteDataSecurityMonitorByIdRequest } from '@api/data-security';
import { getCoreDataSecurityMonitorsSlice } from './get';

export const removeCoreDataSecurityMonitorsSyncSlice = createRemoveSyncSlice({
	name: CoreDataSecurityMonitorsName,
	state: getCoreDataSecurityMonitorsSlice.asyncState,
	transform: (action: DeleteDataSecurityMonitorByIdRequest, state) => ({
		...state,
		results: state?.results.filter((monitor) => action.monitorId !== monitor.id) ?? []
	})
});
